export { SubscriptionConfirmation } from './Confirmation';
export { Instructions } from './Instructions';



// WEBPACK FOOTER //
// ./src/components/presentational/views/Download/sections/index.ts